<app-page-meta pageTitle="finzy - Investor Dashboard"></app-page-meta>
<app-header></app-header>

<div class="container-fluid">
    <div class="row">
        <app-investormenu></app-investormenu>

        <div class="col-xs-12 col-md-10 col-lg-11 finzyright-lenderinitial main-content">
            <div class="row finzy-row41">

                <div *ngIf="lenderApplicationStatus == 'verified'" class="status-indicator">
                    <img src="../../assets/images/tick-green.svg" width="10%">
                </div>
                <div *ngIf="lenderApplicationStatus == 'ready_for_kyc' || lenderApplicationStatus == 'kyc_in_progress'"
                     class="status-indicator">
                    <img src="../../assets/images/time-left.svg" width="10%">
                </div>
                <div class="greet-user">
                    <p class="no-margin-bottom">Welcome {{name}}</p>
                    <p [ngClass]="(lenderApplicationStatus === 'verified')?'color-green':'color-gray'">{{lender_status}}</p>
                </div>
                <p class="finzy-p61"
                   *ngIf="lenderApplicationStatus == 'ready_for_kyc' || lenderApplicationStatus == 'kyc_in_progress'">
                    We will send you an update in <span class="dark">1 business day</span> on your registered
                    phone number and email id.</p>
                <p class="finzy-p61" *ngIf="lenderApplicationStatus == 'verified'">
                    Please top-up your investment wallet to begin investing.</p>
            </div>

            <div class="row finzy-row2">
                <p class="finzy-col x-big-text">In the meanwhile you could setup your investment wallet</p>
                <p class="finzy-p7 small-text">Transfer funds to your Investment wallet. You can start investing with a
                    minimum
                    of ₹50,000
                    in your wallet. Here are your personalised Virtual Account details. Please add this as a beneficiary
                    in your
                    bank account.</p>
                <div class="row walletDetails">
                    <div class="col-md-12 accdetails">
                        <div class="col-sm-6 accdetailsleft"><p class="left">Bank </p></div>
                        <div class="col-sm-6 accdetailsright"><p class="left">ICICI BANK</p></div>
                    </div>
                    <div class="col-md-12 accdetails" *ngIf="virtualAccountNumber">
                        <div class="col-sm-6 accdetailsleft"><p class="left">Virtual Account number </p></div>
                        <div class="col-sm-6 accdetailsright"><p class="left">
                            <span>{{getSubstring(virtualAccountNumber, 0, 10)}}</span>
                            <span><b>{{getSubstring(virtualAccountNumber, 10, virtualAccountNumber.length)}}</b></span>
                            <span class="small-text virtual-account-info" (click)="openVirtualAccountDescriptionPopup()"><a class="finzy-col">How does this work?</a></span>
                        </p></div>
                    </div>
                    <div class="col-md-12 accdetails">
                        <div class="col-sm-6 accdetailsleft"><p class="left">Account name </p></div>
                        <div class="col-sm-6 accdetailsright"><p class="left"> BRIDGE FINTECH SOLUTIONS PVT LTD</p>
                        </div>
                    </div>
                    <div class="col-md-12 accdetails">
                        <div class="col-sm-6 accdetailsleft"><p class="left">Account type </p></div>
                        <div class="col-sm-6 accdetailsright"><p class="left"> CURRENT ACCOUNT</p></div>
                    </div>
                    <div class="col-md-12 accdetails">
                        <div class="col-sm-6 accdetailsleft"><p class="left">IFSC code</p></div>
                        <div class="col-sm-6 accdetailsright"><p class="left"> ICIC0000104</p></div>
                    </div>
                </div>
                <p class="finzy-p7 small-text"><b>Please note that this is a Virtual Account specific to your PAN number
                    and
                    finzy
                    investment
                    account.</b> Money transferred to this Virtual Account cannot be used for any other finzy investment
                    account
                    linked to a different PAN.</p>
                <p class="finzy-p6 small-text">Once you make the transfer, the amount will start reflecting in your
                    wallet.
                    You will also receive a confirmation email.</p>
            </div>
            <div class="row finzy-row42">
                <strong>
                    <p>Loans are getting filled fast on finzy! See the loans funded by other investors <a [routerLink]="['/recently-filled-loans']">here.</a><p>
                </strong>
                <p class="finzy-p6">If you need assistance you can find help here <a target="_blank"
                                                                                     [routerLink]="['/faq']"
                                                                                     class="finzy-col">FAQs</a>. You
                    could even
                    call us on 9341 300 300. We are always happy to help!</p>
            </div>

        </div>
    </div>
</div>

<app-footer></app-footer>
